import {
  PointLight,
  HemisphericLight,
  MeshBuilder,
  Vector3,
  Color3,
  StandardMaterial,
  CubeTexture
} from '@babylonjs/core';

/**
 * Sets up the scene's lights and environment for reflections.
 * 
 * @param {BABYLON.Scene} scene - The Babylon.js Scene.
 * @param {Object} layoutData - Has a "downlights" array, etc.
 * @param {number} ceilingYCoord - Y coord for the ceiling (where lights go).
 */
export function setupLighting(scene, layoutData, ceilingYCoord) {
  // 1) Point lights for each "downlight"
  layoutData.downlights.forEach(([x, z], i) => {
    const lightPos = new Vector3(x, ceilingYCoord - 0.01, z);
    const pointLight = new PointLight(`pointLight_${i}`, lightPos, scene);
    pointLight.intensity = 1;
    pointLight.range = 4;
    pointLight.diffuse = new Color3(1.0, 0.88, 0.7);


    // (Optional) Debug sphere to see where the light is
    /**
    const debugSphere = MeshBuilder.CreateSphere(
      `debugSphereDownlight_${i}`,
      { diameter: 0.05 },
      scene
    );
    const debugMat = new StandardMaterial(`debugMatDownlight_${i}`, scene);
    debugMat.diffuseColor = new Color3(1, 1, 0);
    debugSphere.material = debugMat;
    debugSphere.position = lightPos.clone();
    */
  }); 

  // 2) A simple hemispheric light from above
  const hemi = new HemisphericLight('hemi', new Vector3(0, 1, 0), scene);
  hemi.intensity = 0.2;

  // 3) Environment texture for PBR reflections
  //    Replace 'BASEURL/...' with your actual path/URL.
  
  const BASE_URL = 'https://yuxbcsdfnhttlrmzsqvz.supabase.co/storage/v1/object/public/textures';
  const environmentUrl =`${BASE_URL}/Studio_Softbox_2Umbrellas_cube_specular.env`;

  scene.environmentTexture = CubeTexture.CreateFromPrefilteredData(
    environmentUrl, scene
  );
  scene.environmentIntensity = 0.2;

  // (OPTIONAL) Create a skybox so there's always something to reflect,
  // even if your room geometry is small or behind the mirror's camera.
  //scene.createDefaultSkybox(scene.environmentTexture, /* pbr */ true, /* scale */ 200, /* blur */ 0.3);
}
